import { client, getUrl } from "utils";

export const findByRequestBrandTrackedDomainsRequest = () => client.get(getUrl("brand-tracked-domains"));

export const findByBrandCodeBrandTrackedDomainsRequest = (code) => client.get(getUrl(`brand-tracked-domains/${code}`));
